import { SitecoreFetch } from 'Api/api/SitecoreApi';
import { HttpStatusCodes } from 'Utilities/ClientResponseUtility';

// Issues the anti-forgery cookie/token pair for the authenticated user. The returned token must be
// sent back on anti-forgery protected POSTs, either as the __RequestVerificationToken form field or
// in the X-Request-Verification-Token header (JSON bodies).
const ANTI_FORGERY_TOKEN_ENDPOINT = '/api/sitecore/AIPortal/AntiForgeryToken';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

// Cached for the lifetime of the page and shared by every caller, so protected endpoints issue one
// token request between them rather than one each.
let antiForgeryToken: string | null = null;
let antiForgeryTokenRequest: Promise<string | null> | null = null;

export function getAntiForgeryToken(): Promise<string | null> {
  if (antiForgeryToken) {
    return Promise.resolve(antiForgeryToken);
  }

  if (!antiForgeryTokenRequest) {
    antiForgeryTokenRequest = (async () => {
      try {
        const response = await SitecoreFetch(ANTI_FORGERY_TOKEN_ENDPOINT);
        if (
          response.Status.Code === HttpStatusCodes.OK &&
          isRecord(response.Data) &&
          typeof response.Data.token === 'string'
        ) {
          antiForgeryToken = response.Data.token;
        }

        return antiForgeryToken;
      } finally {
        antiForgeryTokenRequest = null;
      }
    })();
  }

  return antiForgeryTokenRequest;
}
